'use client';

import { useTranslations } from 'next-intl';
import type { UnwrappedPackCardProps } from '~/components/pack-card/unwrapped-pack-sheet';
import { UnwrappedPackCardSheetContent } from '~/components/pack-card/unwrapped-pack-sheet';
import { Sheet, SheetContent, SheetTrigger } from '~/components/ui';
import { BaseCard } from '../base-card';

export const UnwrappedPackCard = ({
  label,
  rarity,
  imageSrc,
  imagePosition = 'cover',
  title,
  brandName,
  className,
  id,
  stakedTill,
  nft,
  ...props
}: UnwrappedPackCardProps) => {
  const t = useTranslations('workshop.staking');
  const isMinted = nft?.nftMintStatus === 'DONE';
  const stakedTillDate = stakedTill ? new Date(stakedTill) : null;
  const now = Date.now();
  const isStaked = stakedTillDate ? stakedTillDate.getTime() > now : false;
  const daysLeft =
    isStaked && stakedTillDate
      ? Math.max(1, Math.ceil((stakedTillDate.getTime() - now) / (24 * 60 * 60 * 1000)))
      : null;

  if (isStaked) {
    return (
      <BaseCard
        brandName={brandName}
        className={className}
        imagePosition={imagePosition}
        imageSrc={imageSrc}
        isMinted={isMinted}
        label={label}
        overlayContent={
          <div
            className="px-4 py-2 rounded-2xl border border-white/10 text-white font-bold text-sm text-center"
            style={{ background: '#0D0D0D' }}
          >
            {daysLeft !== null ? t.rich('staked-days-left', { days: daysLeft, br: () => <br /> }) : t('staked')}
          </div>
        }
        rarity={rarity}
        title={title}
        {...props}
      />
    );
  }

  return (
    <Sheet>
      <SheetTrigger asChild>
        <BaseCard
          {...props}
          brandName={brandName}
          className={className}
          imagePosition={imagePosition}
          imageSrc={imageSrc}
          isMinted={isMinted}
          label={label}
          rarity={rarity}
          title={title}
        />
      </SheetTrigger>
      <SheetContent className="rounded-t-3xl pb-10">
        <UnwrappedPackCardSheetContent brandName={brandName} id={id} rarity={rarity} title={title} />
      </SheetContent>
    </Sheet>
  );
};
